module.exports = __webpack_public_path__ + "static/media/YB5M08_3.570e2650.jpg";